import styled, { css } from "styled-components";
import Image from "next/image";

export const Container = styled.div`
  ${({ theme: { breakpoints } }) => css`
    width: 100%;
    max-width: 1390px;
    margin: 0 auto;
    padding: 32px 15px 488px;
    overflow: hidden;
    min-height: calc(100vh - 290px);

    @media (max-width: ${breakpoints.smDesktopWidth}) {
      position: relative;
      padding-bottom: 0;
    }

    @media (max-width: ${breakpoints.maxTableWidth}) {
      max-width: 100%;
      padding: 24px 40px 0;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 100%;
      padding: 24px 0 0;
      display: flex;
      flex-direction: column;
    }
  `}
`;

export const Wrap = styled.div`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    flex-direction: column;
    gap: 38px;
    position: relative;
    z-index: 1;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      gap: 24px;
      overflow: hidden;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      gap: 28px;
    }
  `}
`;

export const HeaderPageWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1`
  ${({ theme: { breakpoints } }) => css`
    font-size: 40px;
    font-weight: 400;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      font-size: 32px;
      margin: 4px 0 6px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      font-size: 22px;
      margin: 0 0 0 20px;
    }
  `}
`;

export const ContentWrap = styled.section`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 120px;
    position: relative;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      flex-direction: column;
      column-gap: 0;
      row-gap: 40px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      padding: 0 20px;
      row-gap: 19px;
    }
  `}
`;

export const Subtitle = styled.h2`
  ${({ theme: { breakpoints } }) => css`
    font-size: 28px;
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 8px;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      font-size: 26px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      font-size: 18px;
      line-height: 1;
      margin-bottom: 20px;
    }
  `}
`;

export const PhoneWrap = styled.div`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 32px;

    @media (max-width: ${breakpoints.maxTableWidth}) {
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      justify-content: space-between;
    }
  `}
`;

export const CallbackButton = styled.button`
  ${({ theme: { breakpoints, colors } }) => css`
    padding: 0 42px;
    font-size: 13px;
    line-height: 1;
    white-space: nowrap;
    height: 44px;
    background-color: ${colors.white};
    border: 1px solid ${colors.lineGray};
    border-radius: 10.5px;
    margin: 0;

    @media (max-width: ${breakpoints.maxTableWidth}) {
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
    }
  `}
`;

export const NumberInfo = styled.p`
  ${({ theme: { breakpoints } }) => css`
    font-size: 22px;
    line-height: 1.5;
    margin-bottom: 4px;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      font-size: 16px;
      margin-bottom: 0;
    }
  `}
`;

export const BrandNumber = styled.h2`
  ${({ theme: { breakpoints } }) => css`
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 4px;
    font-weight: 400;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      font-size: 16px;
      margin-bottom: 0;
    }
  `}
`;

export const HoursInfo = styled.p`
  ${({ theme: { breakpoints, colors } }) => css`
    font-size: 12px;
    color: ${colors.darkGray};

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      font-size: 10px;
    }
  `}
`;

export const MapWrap = styled.article`
  ${({ theme: { breakpoints } }) => css`
    border-radius: 10.5px;
    overflow: hidden;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      max-width: 100%;
    }
  `}
`;

export const InfoWrap = styled.article`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 42px;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      row-gap: 40px;
      min-width: auto;
      width: auto;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 100%;
      row-gap: 44px;
    }
  `}
`;

export const RegionNameWrap = styled.div`
  ${({ theme: { breakpoints } }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 185px;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      column-gap: 57px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      row-gap: 32px;
    }
  `}
`;

export const RegionName = styled.p`
  ${({ theme: { breakpoints } }) => css`
    font-size: 13px;
    line-height: 1;
    font-weight: 400;
    margin: 0 0 32px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      margin-top: 24px;
      margin-bottom: 0;
    }
  `}
`;

export const ServiceList = styled.ul`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 32px;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      row-gap: 16px;
      display: none;
    }
  `}
`;

export const ServiceListMobile = styled.ul`
  ${({ theme: { breakpoints } }) => css`
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 32px;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      row-gap: 16px;
      display: flex;
    }
  `}
`;

export const HotlineWrap = styled.div`
  ${({ theme: { breakpoints } }) => css`
    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 100%;
    }
  `}
`;

export const PhoneInfo = styled.div``;

export const ServiceWrap = styled.div``;

export const RegionSpanName = styled.span`
  ${({ theme: { breakpoints } }) => css`
    margin-left: 8px;
  `}
`;

export const MapInnerWrap = styled.div`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    justify-content: center;
    align-items: flex-start;
  `}
`;

export const BackgroundImageDesktop = styled(Image)`
  ${({ theme: { breakpoints } }) => css`
    width: 835px;
    margin-left: auto;
    position: absolute;
    bottom: 0;
    right: 0;

    @media (max-width: ${breakpoints.smDesktopWidth}) {
      display: none;
    }

    @media (max-width: ${breakpoints.maxTableWidth}) {
      display: none;
    }
  `}
`;

export const BackgroundImageTablet = styled(Image)`
  ${({ theme: { breakpoints } }) => css`
    width: 688px;
    display: none;

    @media (max-width: ${breakpoints.smDesktopWidth}) {
      display: block;
      margin-left: auto;
      margin-right: -40px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 100%;
    }
  `}
`;

export const BackgroundImageMobile = styled(Image)`
  ${({theme: {breakpoints}}) => css`
    width: 100%;
    display: none;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
    }
  `}
`
